document.addEventListener('DOMContentLoaded', () => {
  const drawerExists = () => document.querySelector('#FilterDrawer');

  if (!drawerExists()) return;

  /*
   * OPEN DRAWER
   */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-filter-open]');

    if (!trigger) return;

    const drawer = document.querySelector('#FilterDrawer');

    if (!drawer) return;

    drawer.classList.add('is-open');

    document.body.classList.add('overflow-hidden');
    drawer.querySelector('.range-min')?.dispatchEvent(
      new Event('input', { bubbles: true })
    );
  });

  /*
   * CLOSE DRAWER
   */
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-filter-close]')) return;

    if (!event.target.closest('#FilterDrawer')) return;

    closeDrawer();
  });

  /*
   * ESC CLOSE
   */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    closeDrawer();
  });

  function closeDrawer() {
    const drawer = document.querySelector('#FilterDrawer');

    if (!drawer) return;

    drawer.classList.remove('is-open');

    document.body.classList.remove('overflow-hidden');
  }

  /*
   * ACCORDIONS
   */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-filter-accordion]');

    if (!button) return;

    const group = button.closest('[data-filter-group]') ||
      button.closest('.group\\/accordion');

    if (!group) return;

    group.classList.toggle('is-collapsed');
  });

  document.addEventListener('input', (event) => {
    const filterSearch = event.target.closest('[data-filter-search]');

    if (!filterSearch) return;

    const group = filterSearch.closest('[data-filter-group]');
    const searchableList = group ? group.querySelector('[data-filter-search-list]') : null;

    if (!searchableList) return;

    const search = filterSearch.value.trim().toLowerCase();

    searchableList.querySelectorAll('[data-filter-search-name]').forEach((item) => {
      const itemName = item.dataset.filterSearchName || '';
      item.classList.toggle('hidden', !(!search || itemName.includes(search)));
    });
  });

  /*
   * APPLY FILTERS / SORT
   *
   * Uses the theme's core facet engine (facets.js / FacetFiltersForm) to do
   * the actual AJAX fetch + section swap, rather than a custom fetch. This
   * keeps us on the same fetch caching, URL history handling, and analytics
   * event hooks the rest of the theme's facets already rely on.
   *
   * We deliberately do NOT wrap this form in a <facet-filters-form> custom
   * element: that element auto-attaches a debounced auto-submit-on-input
   * listener in its constructor (live filtering as you check boxes), which
   * is not the behavior we want here — Apply Filters should be the only
   * trigger. Calling the static FacetFiltersForm.renderPage() directly
   * gives us the same AJAX behavior without that side effect.
   */
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('#CollectionFiltersForm');

    if (!form) return;

    if (typeof FacetFiltersForm === 'undefined') {
      console.error('facets.js has not loaded — FacetFiltersForm is unavailable.');
      return;
    }

    event.preventDefault();

    const formData = new FormData(form, event.submitter);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {

      if (value === '') continue; // skip empty min/max price etc.

      params.append(key, value);

    }

    // Close immediately for instant feedback; the grid/drawer content
    // behind it refreshes a moment later once the fetch resolves.
    closeDrawer();

    FacetFiltersForm.renderPage(params.toString(), event);
  });


  /*
   * CLEAR ALL
   */
  document.addEventListener('click', (event) => {

    const clearLink = event.target.closest('[data-filter-clear]');

    if (!clearLink) return;

    if (typeof FacetFiltersForm === 'undefined') {
      console.error('facets.js has not loaded — FacetFiltersForm is unavailable.');
      return;
    }

    event.preventDefault();

    closeDrawer();

    const href = clearLink.href;
    const queryString = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(queryString);
  });

  /*
   * REMOVE FACET
   */
  document.addEventListener('click', (event) => {

    const clearLink = event.target.closest('[data-facet-remove]');

    if (!clearLink) return;

    if (typeof FacetFiltersForm === 'undefined') {
      console.error('facets.js has not loaded — FacetFiltersForm is unavailable.');
      return;
    }

    event.preventDefault();

    closeDrawer();

    const href = clearLink.href;
    const queryString = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);

    FacetFiltersForm.renderPage(queryString);
  });

  if (!window.__t57FilterPopstateBound) {
    window.__t57FilterPopstateBound = true;

    window.addEventListener('popstate', () => {
      if (typeof FacetFiltersForm === 'undefined') return;

      const queryString = window.location.search.slice(1);
      FacetFiltersForm.renderPage(queryString);
    });
  }

  /*
   * PRICE FACET
   */
  document.addEventListener('input', (event) => {
    const input = event.target.closest(
      '.price-range .range-min, .price-range .range-max'
    );

    if (!input) return;

    const range = input.closest('.price-range');

    if (!range) return;
    const minInput = range.querySelector('.range-min');
    const maxInput = range.querySelector('.range-max');
    const progress = range.querySelector('.range-progress');

    const minValue = range.querySelector('.range-min-value');
    const maxValue = range.querySelector('.range-max-value');

    const min = parseFloat(minInput.min);
    const max = parseFloat(minInput.max);

    function updateRange() {
      let minPrice = parseFloat(minInput.value);
      let maxPrice = parseFloat(maxInput.value);

      // Prevent handles from crossing
      if (minPrice > maxPrice) {
        if (document.activeElement === minInput) {
          minPrice = maxPrice;
          minInput.value = maxPrice;
        } else {
          maxPrice = minPrice;
          maxInput.value = minPrice;
        }
      }

      const minPercent = ((minPrice - min) / (max - min)) * 100;
      const maxPercent = ((maxPrice - min) / (max - min)) * 100;

      progress.style.left = `${minPercent}%`;
      progress.style.width = `${maxPercent - minPercent}%`;

      minValue.textContent = `$${minPrice}`;
      maxValue.textContent = `$${maxPrice}`;
    }

    minInput.addEventListener('input', updateRange);
    maxInput.addEventListener('input', updateRange);

    updateRange();
  });
});